import { LoginForm } from './loginForm';
import '../../styles/login.css';

const Login = () => {
  return (
    <div className="login-container">
      <LoginForm />
    </div>
  );
};

export default Login;
